import { ActionTree } from "vuex";
import { State } from "./state";
import { create } from "@/store/Crud/functions/actions";

export default <ActionTree<State, any>>{
  create,
};
